import { Input } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.js';
import { FilterTableFieldName } from './types.js';

export const PercentageInput = ({ name }: { name: FilterTableFieldName }) => {
  const { control } = useFormContext();
  return (
    <Td type="editable" backgroundColor="white" colSpan={2}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Input
            id={name}
            size="sm"
            type="number"
            suffix="%"
            prefix="±"
            autoFocus
            border="hidden"
            borderRadius={0}
            boxShadow="none!important"
            placeholderText="Variance"
            isInvalid={fieldState.invalid}
            noIcon
            onClear={() => {
              field.onChange('');
            }}
            {...field}
          />
        )}
      />
    </Td>
  );
};
